import type { MiAlcance } from '../types/metas.types';

/**
 * ¿Captura la TIENDA (el gerente, desde la app) o sólo el supervisor?
 *
 * Decisión del usuario, 22-oct-2026: «de momento seguir dejando la tarea de
 * capturar la meta a los supervisores … a las tiendas ocultarles el endpoint
 * de metas». Todo lo demás de las fases A y B se queda (dirección, filtro por
 * supervisor, transporte/bodeguero/incapacidad por persona…); lo único que se
 * apaga, sin borrar código, es la captura por la tienda. Con el interruptor
 * apagado el admin se lee como el flujo de dos pasos de antes: el supervisor
 * captura y envía; el regional autoriza o rechaza la tienda completa.
 *
 * El interruptor es POR ENTORNO y lo manda la API en `mi-alcance`
 * (`capturaTienda`, leído de `config.metasColaborador.parametros`): nunca una
 * constante compilada, que apaga o enciende los dos entornos a la vez (ver
 * `docs/lessons/2026-08-31-el-interruptor-que-apago-los-dos-entornos.md`).
 *
 * Sólo `true` lo enciende: si falta (API anterior), viene mal escrito o no hay
 * alcance todavía, es `false` — el flujo que corre en producción.
 */
export const capturaDeTienda = (a: Partial<Pick<MiAlcance, 'capturaTienda'>> | null | undefined): boolean =>
  a?.capturaTienda === true;
